import _ from "lodash";
import moment from "moment";

import { DATETIME_FORMATS } from "globals/constants";

export const formatDatesInFormPayload = (payload, formatter) => {
	const formattedPayload = _.cloneDeep(payload);
	const contentElements = [];
	findContent(formattedPayload, contentElements);
	contentElements.forEach(content => formatObject(content, formatter));

	return formattedPayload;
};

export const formatDatesInObject = (anObject, formatter) => {
	const formattedObject = _.cloneDeep(anObject);
	formatObject(formattedObject, formatter);

	return formattedObject;
};

const formatObject = (anObject, formatter) => {
	for (const property in anObject) {
		const value = anObject[property];
		if (typeof value == "object" && !(value instanceof Date)) {
			formatObject(value, formatter);
		} else {
			const aDate = moment(value, moment.ISO_8601);
			if (aDate.isValid()) {
				const isDateTime = (value instanceof Date) || (typeof value == "string" ? value.includes("T") : false);
				formatter(anObject, property, aDate, isDateTime);
			}
		}
	}
};

export const dateReadFormatter = (anObject, property, aDate, isDateTime) => {
	if (isDateTime) {
		anObject[property] = aDate.toISOString();
	}
};

export const dateWriteFormatter = (anObject, property, aDate, isDateTime) => {
	if (isDateTime) {
		// This works better with some file types like MP4 that may be read only.
		Object.defineProperty(anObject, property, {
			value: aDate.utc().toISOString(),
			writable: true
		});
	}
};

export const getDateTimeLocale = () => {
	const lang = navigator.language ?? navigator.userLanguage;

	return DATETIME_FORMATS.get(lang?.toLowerCase()) ?? DATETIME_FORMATS.get("en-us");
};

export const getDateFormat = extraSettings => {
	const dateTimeFormat = getDateTimeLocale();

	if (extraSettings?.enableTime) {
		extraSettings.format = `${dateTimeFormat.date} ${dateTimeFormat.time}`;
	} else {
		extraSettings.format = dateTimeFormat.date;
	}

	return extraSettings;
};

const findContent = (anObject, contentList) => {
	for (const property in anObject) {
		if (property.endsWith("Content")) {
			contentList.push(anObject[property]);
		}
		if (typeof anObject[property] == "object") {
			findContent(anObject[property], contentList);
		}
	}
};
